module.exports = __webpack_public_path__ + "img/home-hero_jp.72d6012.png";